export type Language = { local: string; code: string; label: string; labelEng: string; suggested?: boolean };

export const langByLocal = (local: string): Language => {
    return languages.find((el) => el.local === local) || defaultLang;
};
export const defaultLang: Language = { local: 'en', code: 'en', label: 'English', labelEng: '(United States)' };
export const navigatorToUs = () => {
    const lang = window.navigator.language;
    if (lang.toLowerCase() === 'zh-cn') return 'zh';
    if (lang.toLowerCase() === 'zh-hk') return 'zh-hk';
    if (lang.toLowerCase() === 'zh-tw') return 'zh-tw';
    if (lang.toLowerCase().indexOf('zh') !== -1) return 'zh';
    if (lang.toLowerCase() === 'en-au') return 'en-au';
    if (lang.toLowerCase() === 'en-gb') return 'en-gb';
    if (lang.toLowerCase().indexOf('en') !== -1) return 'en';
    if (lang.toLowerCase().indexOf('es') !== -1) return 'es';
    if (lang.toLowerCase().indexOf('fr') !== -1) return 'fr';
    if (lang.toLowerCase().indexOf('de') !== -1) return 'de';
    if (lang.toLowerCase().indexOf('ru') !== -1) return 'ru';
    if (lang.toLowerCase().indexOf('it') !== -1) return 'it';
    if (lang.toLowerCase().indexOf('nl') !== -1) return 'nl';
    if (lang.toLowerCase().indexOf('pt') !== -1) return 'pt';
    if (lang.toLowerCase().indexOf('ja') !== -1) return 'ja';
    if (lang.toLowerCase().indexOf('he') !== -1) return 'he';
    if (lang.toLowerCase().indexOf('ko') !== -1) return 'ko';
    if (lang.toLowerCase().indexOf('da') !== -1) return 'da';
    if (lang.toLowerCase().indexOf('tur') !== -1) return 'tur';
    if (lang.toLowerCase().indexOf('nep') !== -1) return 'nep';
    if (lang.toLowerCase().indexOf('tig') !== -1) return 'tig';
    if (lang.toLowerCase().indexOf('fil') !== -1) return 'fil';
    if (lang.toLowerCase().indexOf('ara') !== -1) return 'ara';
    return defaultLang.local;
};
export const languages: Language[] = [
    { local: 'de', code: 'de', label: 'Deutsch', labelEng: '(German)' },
    { local: 'en-au', code: 'en', label: 'English', labelEng: '(Australia)' },
    { local: 'en-gb', code: 'en', label: 'English', labelEng: '(United Kingdom)' },
    { local: 'en', code: 'en', label: 'English', labelEng: '(United States)' },
    { local: 'es', code: 'es', label: 'Español‬', labelEng: '(Spanish)' },
    { local: 'el', code: 'el', label: 'Ελληνικά', labelEng: '(Greek)' },
    { local: 'fr', code: 'fr', label: 'Français', labelEng: '(French)' },
    { local: 'fr-ca', code: 'fr', label: 'Français', labelEng: '(Canada)' },
    { local: 'ru', code: 'ru', label: 'Русский', labelEng: '(Russian)' },
    { local: 'it', code: 'it', label: 'Italiano', labelEng: '(Italian)' },
    { local: 'nl', code: 'nl', label: 'Nederlands', labelEng: '(Dutch)' },
    { local: 'pt', code: 'pt', label: 'Português', labelEng: '(Brasil)' },
    { local: 'zh', code: 'zh', label: '中文简体', labelEng: '(Chinese Simplified)' },
    { local: 'zh-hk', code: 'zh-hk', label: '中文香港', labelEng: '(Chinese Hong Kong)' },
    { local: 'zh-tw', code: 'zh-tw', label: '中文繁體', labelEng: '(Chinese Traditional)' },
    { local: 'ja', code: 'ja', label: '‪日本語‬', labelEng: '(Japanese)' },
    { local: 'he', code: 'he', label: 'עִברִית', labelEng: '(Hebrew)' },
    { local: 'ko', code: 'ko', label: '한국어', labelEng: '(Korean)' },
    { local: 'da', code: 'da', label: 'Dansk', labelEng: '(Danish)' },
    { local: 'tur', code: 'tur', label: 'Türkçe', labelEng: '(Turkish)' },
    { local: 'nep', code: 'nep', label: 'नेपाली', labelEng: '(Nepali)' },
    // { local: 'tig', code: 'tig', label: 'ትግረ', labelEng: '(Tigre)' },
    { local: 'fil', code: 'fil', label: 'Filipino', labelEng: '(Filipino)' },
    { local: 'ara', code: 'ara', label: 'عربي', labelEng: '(Arabic)' },
];

export const toIETF = (language: Language): string => {
    switch (language.local) {
        case 'en-au':
        case 'en-gb':
            return 'en-GB';
        case 'en':
            return 'en-US';
        case 'pt':
            return 'pt-BR';
        case 'zh':
            return 'zh-CN';
        case 'zh-hk':
        case 'zh-tw':
            return 'zh-hk';
    }
    return language.local;
};

export const sendToApi = (lang: string): string => {
    switch (lang) {
        case 'pt':
            return 'pt-BR';
        case 'ja':
            return 'jp';
        case 'he':
            return 'heb';
        case 'zh-hk':
            return 'zh-HK';
        case 'zh':
            return 'zh-CN';
        case 'zh-tw':
            return 'zh-TW';
    }
    return lang;
};

export const parseFromApi = (lang: string): string => {
    switch (lang) {
        case 'pt-BR':
            return 'pt';
        case 'jp':
            return 'ja';
        case 'heb':
            return 'he';
        case 'zh-HK':
            return 'zh-hk';
        case 'zh-CN':
            return 'zh';
        case 'zh-TW':
            return 'zh-tw';
    }
    return lang;
};
export default languages;
